import type { DayState } from '@daily/shared';

export function dayStateFromHour(hour: number): DayState {
  if (hour >= 22 || hour < 5) return 'night';
  if (hour < 12) return 'morning';
  if (hour < 17) return 'afternoon';
  return 'evening';
}

export function greetingFor(state: DayState): string {
  switch (state) {
    case 'morning':
      return 'Good morning, family.';
    case 'afternoon':
      return 'Good afternoon, family.';
    case 'evening':
      return 'Good evening, family.';
    case 'night':
      return 'Goodnight, family.';
  }
}
